export const NO_SCROLL_CLASSNAME = "no-scroll"
export const NO_OVERFLOW_CLASSNAME = "no-overflow"
